/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { dailyReportSchema } from '../../progress/getDashboard/daily-report-schema';
import { levelStatsSchema } from '../../progress/getDashboard/level-stats-schema';
import { overallSchema } from '../../progress/getDashboard/overall-schema';
import { streakSchema } from '../../progress/getDashboard/streak-schema';
import { collectionStatSchema } from './collection-stat-schema';
import { deviceSchema } from './device-schema';
import { preferenceSchema } from './preference-schema';
import { subscriptionSchema } from './subscription-schema';
import { ticketSchema } from './ticket-schema';
import { transactionSchema } from './transaction-schema';

const hardestChallengeSchema = z.object({
  challengeId: z.number(),
  title: z.string(),
  passed: z.number(),
  failed: z.number(),
});

export const getUserDashboardDataSchema = z.object({
  userId: z.string(),
  streak: streakSchema,
  overall: overallSchema,
  levels: z.record(z.string(), levelStatsSchema),
  dailyProgress: z.record(z.string(), dailyReportSchema),
  practiceHours: z.record(z.string(), z.number()),
  hardestChallenges: z.array(hardestChallengeSchema),
  collections: z.array(collectionStatSchema),
  subscriptions: z.array(subscriptionSchema),
  transactions: z.array(transactionSchema),
  devices: z.array(deviceSchema),
  preference: preferenceSchema,
  tickets: z.array(ticketSchema),
});

export type IGetUserDashboardData = z.infer<typeof getUserDashboardDataSchema>;

export const getUserDashboardResponseSchema = createApiResponseSchema(
  getUserDashboardDataSchema,
) as z.ZodSchema<IAPI<IGetUserDashboardData>>;

export type IGetUserDashboardResponse = IAPI<IGetUserDashboardData>;
